import React from 'react';

import { Button, Group, Stack, Text, Modal, Title } from '@mantine/core';
import useDeleteDocument from 'hooks/document/useDeleteDocument';
import useDocument from 'hooks/document/useDocument';
import notificationHandler from 'utils/notifications';

interface IDeleteDocumentModalProps {
  documentId: string | null;
  opened: boolean;
  closeHandler: () => void;
}

const DeleteDocumentModal = ({
  documentId,
  opened,
  closeHandler,
}: IDeleteDocumentModalProps): JSX.Element => {
  const deleteDocumentMutation = useDeleteDocument();
  const { data } = useDocument(documentId || '');

  const handleDelete = (): void => {
    if (documentId) {
      const { successNotification, errorNotification } = notificationHandler();
      deleteDocumentMutation.mutate(documentId, {
        onSuccess: () => {
          successNotification('Document delete success', `${data?.data.description} successfully deleted.`);
        },
        onError: error => {
          errorNotification('Document delete failed', error.response?.data.message);
        },
        onSettled: () => {
          closeHandler();
        },
      });
    }
  };

  return (
    <Modal
      opened={opened}
      onClose={closeHandler}
      title={<Title order={4}>Delete Template</Title>}
      trapFocus
      centered
      size='auto'
    >
      <Stack>
        <Text>{`Are you sure you want to delete ${data?.data.description}?`}</Text>
        <Text color='dimmed'>This action cannot be undone.</Text>
        <Group position='right'>
          <Button
            onClick={handleDelete}
            color='red'
            disabled={deleteDocumentMutation.isLoading}
            data-cy='confirmDeleteTemplateDocument'
          >
            Delete
          </Button>
        </Group>
      </Stack>
    </Modal>
  );
};

export default DeleteDocumentModal;
